import { v4 as uuidv4 } from 'uuid';
import ProjectImg from '../images/projectImg.png';
import UTrackerImg from '../images/utracker.jpg';
import GreenCtgImg from '../images/greenctg.jpg';
import CoinTrackerImg from '../images/cointracker.jpg';
import CavinImg from '../images/cavinimg.jpg';
import RdgImg from '../images/rdg.PNG';

const projects = [
  {
    id: uuidv4(),
    name: 'Health web app: Covid 19 Tracker',
    desc:
      'A web application to track all corona virus data from one place. I developed the website',
    img: UTrackerImg,
    url: <a href="https://covid-19-tracker-80372.web.app/"> Click to see </a>,
  },
  {
    id: uuidv4(),
    name: 'Netflix clone:Kouekam Tv',
    desc:
      'An app that help people to entertain by watching movies. Still under development',
    img: GreenCtgImg,
    url: <a href="https://kouekamtv.web.app/"> Click to see </a>,
  },
  {
    id: uuidv4(),
    name: 'E-commerce webapp :Riding-up',
    desc: 'An ecommerce buisness web app built for the Riding-up company.',
    img: RdgImg,
    url: <a href="https://fabricenguiffo.vercel.app/"> Click to see </a>,
  },
];

export default projects;
